import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Sparkles, Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="studio-bg grain min-h-screen grid place-items-center px-5 py-10 relative">
      <div className="relative z-10 w-full max-w-md fade-up">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#3ECF8E] to-emerald-600 grid place-items-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
          <span className="font-display text-xl font-extrabold">Vira<span className="text-[#3ECF8E]">lyne</span></span>
        </Link>

        <div className="glass rounded-3xl p-8" data-testid="forgot-password-card">
          {sent ? (
            <div className="text-center">
              <MailCheck className="w-16 h-16 text-[#3ECF8E] mx-auto" />
              <h1 className="font-display text-2xl font-bold mt-5">Vérifiez votre email</h1>
              <p className="text-slate-400 mt-2">
                Si un compte existe pour cette adresse, un lien de réinitialisation vient d'être envoyé. Pensez à vos spams.
              </p>
              <Button onClick={() => navigate("/login")} className="mt-6 h-11 px-6 bg-[#3ECF8E] hover:bg-[#2fb879] text-black glow-btn rounded-full font-semibold" data-testid="back-to-login-button">
                Retour à la connexion
              </Button>
            </div>
          ) : (
            <>
              <h1 className="font-display text-2xl font-bold">Mot de passe oublié</h1>
              <p className="text-slate-400 mt-2 text-sm">Entrez votre email, nous vous enverrons un lien de réinitialisation.</p>
              <form onSubmit={submit} className="space-y-4 mt-6">
                <div>
                  <Label className="text-slate-300">Email</Label>
                  <Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                    className="mt-1.5 bg-white/5 border-white/10 h-11" placeholder="vous@exemple.com" data-testid="forgot-email-input" />
                </div>
                <Button type="submit" disabled={loading} className="w-full h-11 bg-[#3ECF8E] hover:bg-[#2fb879] text-black glow-btn rounded-full font-semibold" data-testid="forgot-submit-button">
                  {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Envoyer le lien"}
                </Button>
              </form>
              <button onClick={() => navigate("/login")} className="text-sm text-slate-400 hover:text-white mt-4 transition-colors w-full text-center" data-testid="forgot-back-link">
                Retour à la connexion
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
